import { userService } from "../user.service";
import { alertActions } from "../../../_services/store/alert.actions";
import { history } from "../../../_services/history";
import {
    authenticationReducerActions,
    platformUserReducerActions,
    userRegistrationReducerActions,
} from "../../../_services/store";
import {
    fireGTMTagAfterSuccessfulUserRegistration,
    fireMetaTagAfterSuccessfulUserRegistration,
    getOrganization,
} from "../../../organization/myOrganization/services/store/myOrganization.actions";
import { refreshBasicData } from "../../../commons/services/store/commons.actions";
import { setupActions } from "./setup.actions";
import { clearAccountingTasks } from "../../../features/AccountingTasks/services/store/accountingTasksActions";
import { UserType } from "../../../_statics/UserStatics";
import { selectOrganizationByLogin } from "./authentication.actions";
import { auth } from "../../../firebase";

export const getCurrentUser = () => {
    return async (dispatch) => {
        dispatch(platformUserReducerActions.getUserRequest());
        try {
            const user = await userService.getCurrentUser();
            dispatch(platformUserReducerActions.getUserSuccess(user));
        } catch (error) {
            dispatch(platformUserReducerActions.getUserFailure(error));
        }
    };
};

export const updateUserPassword = (user) => {
    return async (dispatch) => {
        dispatch(platformUserReducerActions.updatePasswordRequest());
        try {
            await userService.updatePassword(user);
            dispatch(platformUserReducerActions.updatePasswordSuccess());
            dispatch(alertActions.generalSuccessAndClear("Das Passwort wurde erfolgreich aktualisiert", 3000));
            dispatch(getOrganization());
        } catch (error) {
            dispatch(platformUserReducerActions.updatePasswordFailure(error));
        }
    };
};

export const updateUser = (user) => {
    return async (dispatch) => {
        dispatch(platformUserReducerActions.updateUserRequest());
        try {
            const updatedUser = await userService.updateUserName(user);
            dispatch(platformUserReducerActions.updateUserSuccess(updatedUser));
            dispatch(alertActions.generalSuccessAndClear("Dein Profil wurde erfolgreich aktualisiert", 3000));
        } catch (error) {
            dispatch(platformUserReducerActions.updateUserFailure(error));
            throw error;
        }
    };
};

export const selectOrganization = (organizationUUID, redirect, redirectionUrl) => {
    return async (dispatch) => {
        dispatch(platformUserReducerActions.switchOrganizationRequest());
        try {
            await userService
                .selectOrganization(organizationUUID)
                .then(async (response) => {
                        const currentUser = auth.currentUser;
                        if (currentUser) {
                            try {
                                // Force refresh the token to get updated claims from Firebase
                                const refreshedToken = await currentUser.getIdToken(true);
                                const tokenResult = await currentUser.getIdTokenResult();
                                const expirationTime = tokenResult.expirationTime;
                                let tokenUser = {
                                    access_token: refreshedToken,
                                    expiration_time: expirationTime,
                                    refresh_token: currentUser.refreshToken,
                                };
                                userService.mergeUserIntoStorage(tokenUser);
                            } catch (tokenRefreshError) {
                                console.error('Failed to refresh Firebase token:', tokenRefreshError);
                                // Continue execution even if token refresh fails
                            }
                        }

                    if (redirect) {
                        history.push(redirectionUrl ? redirectionUrl : "/");
                    }
                    dispatch(platformUserReducerActions.switchOrganizationSuccess());
                    dispatch(alertActions.generalSuccessAndClear("Organisation wurde erfolgreich gewechselt", 3000));
                    dispatch(refreshBasicData());
                    dispatch(setupActions.getSetupStatus());
                    dispatch(clearAccountingTasks());
                })
                .catch((error) => {
                    dispatch(platformUserReducerActions.switchOrganizationFailure(error));
                    dispatch(alertActions.generalErrorAndClear(error, 3000));
                });
        } catch (error) {
            dispatch(platformUserReducerActions.switchOrganizationFailure(error));
            return Promise.reject(error);
        }
    };
};

/*export const register = (user) => {
    return async (dispatch) => {
        dispatch(userRegistrationReducerActions.registerRequest(user));
        try {
            const response = await userService.register(user);
            const userResponse = response.response;
            dispatch(userRegistrationReducerActions.registerRequest(userResponse));
            dispatch(organizationActions.getOrganization());
        } catch (error) {
            dispatch(userRegistrationReducerActions.registerFailure(error));
        }
    };
};*/

export const deleteUser = (externalUUID) => {
    return async (dispatch) => {
        dispatch(platformUserReducerActions.deleteUserRequest());
        try {
            const response = await userService.deleteUser(externalUUID);
            dispatch(platformUserReducerActions.deleteUserSuccess(response));
            dispatch(getOrganization());
            return response;
        } catch (error) {
            dispatch(platformUserReducerActions.deleteUserFailure(error));
        }
    };
};

export const registerWithAuthData = (registrationData) => {
    return async (dispatch) => {
        dispatch(userRegistrationReducerActions.registerWithAuthDataRequest());
        try {
            const response = await userService.registerWithAuthData(registrationData);
            fireGTMTagAfterSuccessfulUserRegistration();
            fireMetaTagAfterSuccessfulUserRegistration();
            dispatch(userRegistrationReducerActions.registerWithAuthDataSuccess());
            return response;
        } catch (error) {
            dispatch(userRegistrationReducerActions.registerWithAuthDataFailure(error));
        }
    };
};

export const updateLastLogin = () => {
    return () => {
        try {
            userService.updateLastLogin();
        } catch (error) {
            console.error("Error updating last login:", error);
        }
    };
};

export const autologinShopifyWithNounce = (shop, nounce, authDataExternalUUID) => {
    const reject = "Missing one time token";
    const requestBody = {
        shop: shop,
        nounce: nounce,
        authDataExternalUUID: authDataExternalUUID,
    };
    return async (dispatch) => {
        dispatch(userRegistrationReducerActions.autoLoginShopifyRequest());
        try {
            const user = await userService.autologinShopify(requestBody);
            if (user.oneTimeToken) {
                try {
                    const oneTimeUser = await userService.useOneTimeShopifyToken(user.oneTimeToken);
                    dispatch(authenticationReducerActions.updateLoggedInUserSuccess(oneTimeUser));
                    
                    const currentUser = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
                    if (!currentUser?.selectedOrganization && currentUser.availableOrganizations.length === 1) {
                        await dispatch(selectOrganizationByLogin(currentUser.availableOrganizations[0]?.externalUUID, null, null));   
                    }
                    history.push("/");

                    dispatch(userRegistrationReducerActions.autoLoginShopifySuccess());

                } catch (e) {
                    dispatch(userRegistrationReducerActions.autoLoginShopifyFailure(e));
                    return Promise.reject(reject);
                }
            } else {
                dispatch(userRegistrationReducerActions.autoLoginShopifyFailure(reject));
                return Promise.reject(reject);
            }
        } catch (error) {
            dispatch(userRegistrationReducerActions.autoLoginShopifyFailure(error));
            return Promise.reject("Missing one time token");
        }
    };
};

export const autoLoginShopifyWithOneTimeToken = (oneTimeToken) => {
    const reject = "Auto login Error";
    return async (dispatch) => {
        dispatch(userRegistrationReducerActions.autoLoginShopifyRequest());
        try {
            if (oneTimeToken) {
                try {
                    const oneTimeUser = await userService.useOneTimeShopifyToken(oneTimeToken);
                    const currentUser = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
                    if (!currentUser?.selectedOrganization && currentUser.availableOrganizations.length === 1) {
                        await dispatch(selectOrganizationByLogin(currentUser.availableOrganizations[0]?.externalUUID, null, null));   
                    }
                    dispatch(authenticationReducerActions.updateLoggedInUserSuccess(oneTimeUser));
                    history.push("/");
                    dispatch(userRegistrationReducerActions.autoLoginShopifySuccess());
                } catch (e) {
                    dispatch(userRegistrationReducerActions.autoLoginShopifyFailure(e));
                    return Promise.reject(reject);
                }
            } else {
                dispatch(userRegistrationReducerActions.autoLoginShopifyFailure(reject));
                return Promise.reject(reject);
            }
        } catch (error) {
            dispatch(userRegistrationReducerActions.autoLoginShopifyFailure(error));
            return Promise.reject(reject);
        }
    };
};

export const autologinLexOffice = (id, nounce) => {
    const requestBody = { id: id, nounce: nounce };
    return async (dispatch) => {
        dispatch(userRegistrationReducerActions.autoLoginLexOfficeRequest());
        try {
            const response = await userService.autologinLexOffice(requestBody);
            if (response.token) {
                try {
                    const user = await userService.useOneTimeLexOfficeToken(response.token);
                    dispatch(authenticationReducerActions.loginSuccess(user));
                    dispatch(userRegistrationReducerActions.autoLoginLexOfficeSuccess());
                    history.push("/lexoffice");
                    return user;
                } catch (e) {
                    dispatch(userRegistrationReducerActions.autoLoginLexOfficeFailure(e));
                }
            }
            if (response.errorMessage && response.errorMessage.length > 0) {
                const error = response.errorMessage;
                dispatch(userRegistrationReducerActions.autoLoginLexOfficeFailure(error));
            }
            return response;
        } catch (error) {
            dispatch(userRegistrationReducerActions.autoLoginLexOfficeFailure(error));
        }
    };
};

export const sendCelloRegistrationData = (ucc, user) => {
    return () => {
        if (
            !ucc ||
            !user ||
            !user.externalUUID ||
            !user.selectedOrganization?.externalUUID ||
            !user.createdAt ||
            user.platformUserType === UserType.TAXCONSULTANT
        ) {
            return;
        }

        const details = {
            celloUcc: ucc,
            userExternalUUID: user.externalUUID,
            organizationExternalUUID: user.selectedOrganization.externalUUID,
            createdAt: user.createdAt,
        };

        userService.sendCelloRegistrationData(details).catch((error) => {
            console.error("Error sending Cello registration data:", error);
        });
    };
};
